import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'restoration';
export const restorationServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const RestorationServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: restorationServiceEventType(),
}));
